import React, { useState } from 'react';

import API from '../api';

const LEARNING_PATH_URL = 'https://sellercentral.amazon.in/gc/seller-university/advanced-learning-path?ref=quiz_page';
const CREDITS_URL = 'https://sellercentral.amazon.in/gc/seller-university/advanced-learning-path/credits';


export default function SellerLogin() {
  const [sellerId, setSellerId] = useState('');
  // const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Trim whitespace from inputs
    const trimmedSellerId = sellerId.trim();
    // const trimmedUsername = username.trim();

    if (!trimmedSellerId) {
      setError('Merchant Token ID is required');
      return;
    }

    // if (!trimmedUsername) {
    //   setError('Username is required');
    //   return;
    // }

    // Check length: 12 to 16 characters
    if (trimmedSellerId.length < 12 || trimmedSellerId.length > 15) {
      setError('Please enter a valid Merchant Token ID');
      return;
    }

    // Check alphanumeric only
    if (!/^[a-zA-Z0-9]+$/.test(trimmedSellerId)) {
      setError('Please enter a valid Merchant Token ID');
      return;
    }

    // Convert to lowercase for case-insensitive storage
    const lowerSellerId = trimmedSellerId.toLowerCase();
    // const lowerUsername = trimmedUsername.toLowerCase();

    try {
      const res = await API.post('/seller-login', {
        sellerId: lowerSellerId,
        // username: lowerUsername,
      });

      // Save authentication data
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('role', res.data.role);
      // localStorage.setItem('username', res.data.username);
      localStorage.setItem('sellerId', res.data.sellerId);

      // Redirect to dashboard
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    }
  };

return (
    <div className="sl-page">
      <div className="sl-container">
        {/* Dark Left Panel */}
        <div className="sl-dark-panel">
          <div className="sl-deco-bracket-tl" aria-hidden="true" />
          <div className="sl-deco-bracket-br" aria-hidden="true" />
          <div className="sl-deco-rings" aria-hidden="true" />
          <div className="sl-deco-particles" aria-hidden="true" />
          <div className="sl-dark-inner">
            <img src="/scaling_white_background.png" alt="Amazon" className="sl-brand-logo" />

            <h1 className="sl-headline">
              The Complete Guide<br />for <span>Experienced<br />Sellers!</span>
            </h1>

            <p className="sl-subheadline">Master Amazon's tools and unlock exclusive ad credits.</p>

            <div className="sl-timeline">
              <div className="sl-timeline-step">
                <div className="sl-timeline-marker">
                  <div className="sl-timeline-num">1</div>
                  <div className="sl-timeline-line" />
                </div>
                <div className="sl-timeline-content">
                  <h4>Complete the learning path</h4>
                  <p>Work through expert-curated Amazon seller modules</p>
                </div>
              </div>

              <div className="sl-timeline-step">
                <div className="sl-timeline-marker">
                  <div className="sl-timeline-num">2</div>
                  <div className="sl-timeline-line" />
                </div>
                <div className="sl-timeline-content">
                  <h4>Take the assessment quiz</h4>
                  <p>Pass 60% in this knowledge assessment</p>
                </div>
              </div>

              <div className="sl-timeline-step">
                <div className="sl-timeline-marker">
                  <div className="sl-timeline-num">3</div>
                </div>
                <div className="sl-timeline-content">
                  <h4>Unlock ₹1 Lakh credits*</h4>
                  <p>Earn verified seller status &amp; ad credits</p>
                </div>
              </div>
            </div>

            <p className="sl-disclaimer">
              *Additional terms and conditions will apply on{' '}
              <a href={CREDITS_URL} target="_blank" rel="noreferrer" className="sl-disclaimer-link">credits</a>.
            </p>
            <img src="/login_new_try.png" alt="" className="sl-rocket-mobile" />
          </div>
        </div>

        {/* Light Right Panel */}
        <div className="sl-light-panel">
          <div className="sl-card">
            <h2 className="sl-card-title">Sign In</h2>
            <p className="sl-card-sub">Enter your credentials to begin.</p>

            <form onSubmit={handleSubmit}>
              <label className="sl-label">Merchant Token ID</label>
              <input
                type="text"
                className={`sl-input${error ? ' sl-input-error' : ''}`}
                value={sellerId}
                onChange={(e) => setSellerId(e.target.value)}
                placeholder="e.g. A1B2C3D4E5F6G"
              />

              {error && (
                <div className="sl-error">
                  <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M10 7v3M10 13h.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  {error}
                </div>
              )}

              <button type="submit" className="sl-submit">
                CONTINUE
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>

            <div className="sl-divider">
              <span className="sl-divider-text">Need a token?</span>
            </div>

            <a
              href="https://sellercentral.amazon.in/sw/AccountInfo/MerchantToken/step/MerchantToken"
              target="_blank"
              rel="noreferrer"
              className="sl-help-link"
            >
              Find your Merchant Token ID
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                <path d="M4 12l8-8M7 4h5v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>

            <a
              href={LEARNING_PATH_URL}
              target="_blank"
              rel="noreferrer"
              className="sl-help-link"
            >
              Watch the learning path videos
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                <path d="M4 12l8-8M7 4h5v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        <img src="/login_new_try.png" alt="" className="sl-rocket" />
      </div>
    </div>
  );

}
